import {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useLanguage} from '../../../contexts/useLanguage';
import homeLogo from '../../../assets/readdy/396f56bc326bf3bb0133c4916831ad74__cbe207e010.png';
import mLogo from '../../../assets/logoNoText.png';
import styles from './styles/navbar.module.scss'

export default function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
    const {language, setLanguage, t} = useLanguage();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <nav
            className={styles.index + ` fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 py-4">
                <div className="flex items-center justify-between">
                    <div className={
                        "flex items-center space-x-3 cursor-pointer " + styles.mLogoBox
                    } onClick={() => navigate('/')}>

                        {/*<img*/}
                        {/*    src={homeLogo}*/}
                        {/*    alt="ComiAI Logo"*/}
                        {/*    className={styles.logo + " h-10 w-auto"}*/}
                        {/*/>*/}
                        <img
                            src={mLogo}
                            alt="ComiAI Logo"
                            className={styles.mLogo}
                        />
                        <span
                            className={styles.title + ` text-xl font-bold  ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`}>
              {t('可画科技国际有限公司', 'ComiAIte Technology International Limited')}
            </span>
                    </div>

                    <div className={"flex items-center space-x-8 " + styles.menuBox}>
                        <button
                            onClick={() => scrollToSection('overview')}
                            className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
                            } ` + styles.mTitleBox}
                        >
                            {t('关于我们', 'About Us')}
                        </button>
                        <button
                            onClick={() => scrollToSection('products')}
                            className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
                            } ` + styles.mTitleBox}
                        >
                            {t('产品', 'Products')}
                        </button>
                        <button
                            onClick={() => scrollToSection('team')}
                            className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
                            } ` + styles.mTitleBox}
                        >
                            {t('团队', 'Team')}
                        </button>

                        <button
                            onClick={() => navigate('/contact')}
                            className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
                            } ` + styles.mTitleBox}
                        >
                            {t('联系我们', 'Contact Us')}
                        </button>

                        {/* Language Switcher */}
                        <div
                            className={"flex items-center space-x-2 bg-gray-100 rounded-full p-1 " + styles.languageSwitcher}>
                            <button
                                onClick={() => setLanguage('zh')}
                                className={`px-3 py-1.5 text-xs font-bold rounded-full transition-all whitespace-nowrap cursor-pointer ${
                                    language === 'zh'
                                        ? 'bg-red-600 text-white shadow-md'
                                        : 'text-gray-600 hover:text-gray-900'
                                }`}
                            >
                                中
                            </button>
                            <button
                                onClick={() => setLanguage('en')}
                                className={`px-3 py-1.5 text-xs font-bold rounded-full transition-all whitespace-nowrap cursor-pointer ${
                                    language === 'en'
                                        ? 'bg-red-600 text-white shadow-md'
                                        : 'text-gray-600 hover:text-gray-900'
                                }`}
                            >
                                Eng
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}
